// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"528":"reports","594":"about"}[chunkId] + "." + {"528":"ab82a0b1","594":"bf094224"}[chunkId] + ".css";
};